import { ViewModelFieldName } from "../../Engine/src/Engine/Core/CoreTypes";
import { reject } from "../TypingUtils";

import {
    createRelativeFromMask,
    createRelativeResolvedModelPath,
    PathToken,
    RelativeModelPath,
    RelativeResolvedModelPath,
} from "./ModelPath";
import { ViewModelFieldNameWithCustomFields } from "./AbsoluteModelFieldPath";
import { BaseModelFieldPath } from "./BaseModelFieldPath";

export class RelativeModelFieldPath extends BaseModelFieldPath<RelativeModelPath> {
    public constructor(path: RelativeModelPath, fieldName: ViewModelFieldNameWithCustomFields) {
        super(path, fieldName);
    }

    public static createFromString(
        pathWithFieldName: string,
        defaultFieldName?: ViewModelFieldNameWithCustomFields
    ): RelativeModelFieldPath {
        return this.createFrom(pathWithFieldName, path => createRelativeResolvedModelPath(path), defaultFieldName);
    }

    public static createFromMask(
        pathWithFieldName: string,
        multiplicitySymbol: PathToken,
        defaultFieldName?: ViewModelFieldNameWithCustomFields
    ): RelativeModelFieldPath {
        return this.createFrom(
            pathWithFieldName,
            path => createRelativeFromMask(path, multiplicitySymbol),
            defaultFieldName
        );
    }

    private static createFrom<TModelPath extends RelativeModelPath | RelativeResolvedModelPath>(
        pathWithFieldName: string,
        modelPathFactory: (path: string) => TModelPath,
        defaultFieldName: ViewModelFieldNameWithCustomFields = "value"
    ): RelativeModelFieldPath {
        const match = RelativeModelFieldPath.fieldExtractRegex.exec(pathWithFieldName);
        const path = match != undefined ? (match[1] ?? reject()) : pathWithFieldName;
        const field =
            match != undefined ? ((match[2] as ViewModelFieldName | undefined) ?? reject()) : defaultFieldName;

        return new RelativeModelFieldPath(modelPathFactory(path), field);
    }
}
